import TokenAnalyzerTokenAddress from "./TokenAnalyzerTokenAddress";

export default TokenAnalyzerTokenAddress;